import BannerForm from '../model/form.model';
import { randomTrackingCode } from '../randomTrackingCode';

class FormController {
  constructor(MarketingApiService, FormService, BannerImagePreviewFactory) {
    'ngInject';

    this.MarketingApiService = MarketingApiService;
    this.FormService = FormService;
    this.BannerImagePreviewFactory = BannerImagePreviewFactory;
  }

  $onInit() {
    this.form = new BannerForm();
  }

  submit() {
    this.FormService.isSubmitting.next(true);
    this.MarketingApiService.generate(this.form.toPayload())
    .then((response) => {
        this.onSuccessfulSubmission({response: response });
        this.FormService.isSubmitting.next(false);
        this.form.props.readOnly = true;
        this.form.clearErrors();
      })
      .catch((errors) => {
        this.form.errors = errors;
        this.FormService.isSubmitting.next(false);
      })
      ;
  }

  previewBanner() {
    let filename = this.BannerImagePreviewFactory.getPreviewableBanner(this.form);
    this.onBannerPreview({
      filename: filename,
      allowDownload: false,
    });
  }

  reset() {
    this.form.clear();
    this.onFormReset();
  }

  createRandomTrackingCode() {
    this.form.trackingCode = randomTrackingCode();
  }

  onPreventableKeydown(event) {
    if (event.which === 32) {
      event.preventDefault();
    }
  }        
}

export default FormController;


// WEBPACK FOOTER //
// ./client/app/pages/marketing/component/form.controller.js